import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

export default function CompSelectorNoResults() {
  return (
    <div className="no-results">
      <FontAwesomeIcon icon={faSearch} />
      <h3>No comps found</h3>
      <div>Try searching again or clearing your filters</div>
    </div>
  );
}
